import Image from 'next/image';
import {useI18n} from '@udemy-v2/i18n';

import styles from './hero-section.module.scss';
import VideoPlayer from '@/features/60dayhustle/components/video-player/video-player';

const COURSE_LINK = 'https://www.udemy.com/course/60dayhustle/';
const IS_AVAILABLE = true;

export const HeroSection = () => {
    const {gettext} = useI18n();

    return (
        <div className={styles.container}>
            <div className={styles['content-section']}>
                <div className={styles['logo-container']}>
                    <Image
                        src="https://frontends.udemycdn.com/frontends-landing-pages/60-day-hustle/images/60-day-hustle-white-logo.png"
                        alt="60 day hustle - udemy logo"
                        width={600}
                        height={200}
                        className={styles.logo}
                    />
                </div>
                <p className={styles.description}>
                    {gettext(
                        'As the official skills partner of the show, we help hustlers learn everything they need to glow up — from the perfect pitch to sustainable scalability.',
                    )}
                </p>
            </div>
            <div
                className={`${styles['cta-banner']} ${!IS_AVAILABLE && styles['banner-text-center']}`}
            >
                {IS_AVAILABLE ? (
                    <>
                        <p>
                            {gettext(
                                'Take your hustle from low key to the spotlight with exclusive behind-the-scenes content from the show.',
                            )}
                        </p>
                        <a
                            href={COURSE_LINK}
                            className={styles['cta-banner-link']}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {gettext('Get free course')}
                        </a>
                    </>
                ) : (
                    <p className={styles['coming-soon-text-container']}>
                        <span className={styles['coming-soon-text']}>
                            {gettext('COMING SOON: ')}
                        </span>
                        {gettext('Your free course with exclusive behind-the-scenes content')}
                    </p>
                )}
            </div>
            <div className={styles['video-section']}>
                <VideoPlayer
                    videoSrc={
                        IS_AVAILABLE
                            ? '60-day-hustle/videos/60dh-phase2-v2.mp4'
                            : '60-day-hustle/videos/60dh-video-v2.mp4'
                    }
                    posterSrc={
                        IS_AVAILABLE
                            ? '60-day-hustle/images/phase2-thumbnail.jpg'
                            : '60-day-hustle/images/phase1-thumbnail.jpg'
                    }
                />
            </div>
        </div>
    );
};
